import { render, staticRenderFns } from "./pubStatisticChart.vue?vue&type=template&id=18484d6e&scoped=true"
import script from "./pubStatisticChart.vue?vue&type=script&lang=js"
export * from "./pubStatisticChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18484d6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18484d6e')) {
      api.createRecord('18484d6e', component.options)
    } else {
      api.reload('18484d6e', component.options)
    }
    module.hot.accept("./pubStatisticChart.vue?vue&type=template&id=18484d6e&scoped=true", function () {
      api.rerender('18484d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/pubStatisticChart.vue"
export default component.exports